import { render, staticRenderFns } from "./ReporteProduccionAreas.vue?vue&type=template&id=06e0272c&"
import script from "./ReporteProduccionAreas.vue?vue&type=script&lang=js&"
export * from "./ReporteProduccionAreas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports